import { FC } from "react";
import { Link } from "react-router";

import { useAppSelector } from "../../hooks";
import { selectAuthIsAgency } from "../../store/selectors/auth";
import { ERoutes } from "../../constants/routes";

import styles from "./AgencyModeCard.module.css";

const cls = (el?: string) => styles[el ? `agency-card__${el}` : "agency-card"];

const AgencyModeCard: FC = () => {
  const isAgency = useAppSelector(selectAuthIsAgency);

  return (
    <div className={cls()}>
      {isAgency ? (
        <>
          <div className={cls("badge")}>
            <span className={cls("badge-icon")}>✅</span>
            Agency Mode Active
          </div>
          <p className={cls("text")}>
            Manage your clients from the{" "}
            <Link to={ERoutes.Agency} className={cls("link")}>Agency Dashboard</Link>.
          </p>
        </>
      ) : (
        <>
          <h3 className={cls("title")}>🏢 Manage Multiple Clients?</h3>
          <p className={cls("text")}>
            Add your first client in the{" "}
            <Link to={ERoutes.Agency} className={cls("link")}>Agency Dashboard</Link>{" "}
            to start managing accounts from one place.
          </p>
        </>
      )}
    </div>
  );
};

export default AgencyModeCard;
